import React from 'react';

import Button from '../../../components/ui/Button';

const OrdersTable = ({ orders, onViewDetails, onUpdateStatus, selectedOrders, onSelectOrder, onSelectAll }) => {
  const getStatusColor = (status) => {
    const colors = {
      '주문 접수': 'bg-blue-100 text-blue-800',
      '픽업 예정': 'bg-yellow-100 text-yellow-800',
      '세탁 중': 'bg-purple-100 text-purple-800',
      '배송 예정': 'bg-orange-100 text-orange-800',
      '완료': 'bg-green-100 text-green-800'
    };
    return colors?.[status] || 'bg-gray-100 text-gray-800';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date?.getFullYear()}.${String(date?.getMonth() + 1)?.padStart(2, '0')}.${String(date?.getDate())?.padStart(2, '0')}`;
  };

  const formatPrice = (price) => {
    return `${price?.toLocaleString('ko-KR')}원`;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="border-b border-border bg-muted/50">
          <tr>
            <th className="px-4 py-3 text-left">
              <input
                type="checkbox"
                checked={selectedOrders?.length === orders?.length && orders?.length > 0}
                onChange={onSelectAll}
                className="h-4 w-4 rounded border-border text-accent focus:ring-2 focus:ring-accent"
              />
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">주문번호</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">고객명</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">연락처</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">주소</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">항목 수</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">상태</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">주문일</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">금액</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">작업</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {orders?.map((order) => (
            <tr key={order?.id} className="hover:bg-muted/30 transition-colors duration-150">
              <td className="px-4 py-3">
                <input
                  type="checkbox"
                  checked={selectedOrders?.includes(order?.id)}
                  onChange={() => onSelectOrder(order?.id)}
                  className="h-4 w-4 rounded border-border text-accent focus:ring-2 focus:ring-accent"
                />
              </td>
              <td className="px-4 py-3 text-sm font-medium text-foreground">{order?.orderNumber}</td>
              <td className="px-4 py-3 text-sm text-foreground">{order?.customerName}</td>
              <td className="px-4 py-3 text-sm text-muted-foreground">{order?.phone}</td>
              <td className="px-4 py-3 text-sm text-muted-foreground">{order?.address}</td>
              <td className="px-4 py-3 text-sm text-foreground">{order?.itemsCount}개</td>
              <td className="px-4 py-3">
                <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getStatusColor(order?.status)}`}>
                  {order?.status}
                </span>
              </td>
              <td className="px-4 py-3 text-sm text-muted-foreground">{formatDate(order?.orderDate)}</td>
              <td className="px-4 py-3 text-sm font-medium text-foreground">{formatPrice(order?.totalAmount)}</td>
              <td className="px-4 py-3">
                <div className="flex items-center space-x-2">
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Eye"
                    onClick={() => onViewDetails(order)}
                    className="h-8 w-8 p-0"
                  />
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Edit"
                    onClick={() => onUpdateStatus(order)}
                    className="h-8 w-8 p-0"
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersTable;